<template>
  <div class="spa-reservation-heading container">
    <div class="spa-reservation-heading__top">
      <a
        :href="`/${lang}${spaReservationPage}#/spa-soft?hotelCode=${reservationDetailsData.hotelCode}`"
        class="spa-reservation-heading__back-link"
      >
        {{ tc('spaSoft.reservationdetails.reserveAnotherSpaAppointmentCta') }}
      </a>
    </div>

    <div class="spa-reservation-heading__main">
      <h1 class="spa-reservation-heading__title">
        {{ tc('spaSoft.reservationdetails.reservationTitle') }}
      </h1>

      <div class="spa-reservation-heading__status-actions">
        <span
          class="spa-reservation-heading__badge"
          :class="`--${isReservationCancelled ? 'cancelled' : 'confirmed'}`"
        >
          {{ isReservationCancelled ?
            tc('spaSoft.reservationdetails.reservationStatusCancelled') :
            tc('spaSoft.reservationdetails.reservationStatusConfirmed') }}
        </span>
        <!-- <div
          v-if="isReservationCancelled"
          class="spa-reservation-heading__cancellation-number"
        >
          <span>{{ tc('spaSoft.reservationdetails.cancelDetails.cancellationCodeLabel') }}</span>
          <span>1234567890X</span>
        </div> -->
        <!-- <div
          v-if="!isReservationCancelled"
          class="spa-reservation-heading__actions"
        >
          <button
            type="button"
            class="spa-reservation-heading__action-btn"
            @click.prevent="addToCalendar"
          >
            <span class="icon-calendar" />
          </button>
          <button
            type="button"
            class="spa-reservation-heading__action-btn"
            @click.prevent="emailReservation"
          >
            <span class="icon-envelope" />
          </button>
          <button
            type="button"
            class="spa-reservation-heading__action-btn"
            @click.prevent="printReservation"
          >
            <span class="icon-printer" />
          </button>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'SpaReservationHeading',
    inject: ['spaReservationPage'],
    computed: {
      ...mapState('global', ['lang']),
      ...mapState('spaSoft', ['reservationDetailsData']),
      ...mapGetters('spaSoft', ['isReservationCancelled']),
      ...mapGetters('i18n', ['tc']),
    },
    methods: {
      addToCalendar() {
        // TODO: Implement calendar functionality
      },
      emailReservation() {
        // TODO: Implement email functionality
      },
      printReservation() {
        window.print()
      }
    }
  }
</script>
